// extracted by mini-css-extract-plugin
export default {"container":"RJY9QYiQ8S72LEyddAEC","color":"evnWzioblMfgkPcH1mLK"};